import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { base_host, environment, my_port, my_protocol } from 'src/environments/environment';
import { FileUploaderService } from '../service/file-uploader.service';
import { AdminSidebarComponent } from '../admin-sidebar/admin-sidebar.component';

@Component({
  selector: 'app-admin-single-param',
  standalone: false,
  templateUrl: './admin-single-param.component.html',
  styleUrls: ['./admin-single-param.component.css']
})
export class AdminSingleParamComponent implements OnInit {

  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private fileUploaderService: FileUploaderService,
    private authService: AuthService) {

     }


  paramList = [];
  hooks = [];
  routeID:string = this.route.snapshot.params.id;
  authToken = localStorage.getItem('auth');
  attachmentObj;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };


  ngOnInit(): void {
    this.fetchParam();
  }

  fetchParam() {
    this.http.get(environment.ADMIN_PARAMS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.paramList = res.message[this.routeID];
          console.log(this.paramList);
          if(this.routeID == "opening-categories"){
            this.fetchHooks();
          }
          else if(this.routeID == 'banners' || this.routeID == 'banners-employer'){
            setTimeout(() => {
              for (let i = 0; i < this.paramList.length; i++) {
                const param = this.paramList[i];
  
                //set start_date and end_date and country_code
                (<HTMLInputElement>document.getElementById('start_date-' +i )).value = param.start_date;
                (<HTMLInputElement>document.getElementById('end_date-' +i )).value = param.end_date;
                (<HTMLInputElement>document.getElementById('country_code-' +i )).value = param.country_code;
                (<HTMLInputElement>document.getElementById('link-' +i )).value = param.link;
                (<HTMLSelectElement>document.getElementById('banner_type-' +i )).value = param.banner_type;
                
              }
            },400)

          }

        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  fetchHooks() {
    this.http.get(environment.ADMIN_PARAMS + '/hooks', this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.hooks = res.message['hooks'];
          console.log(this.hooks, 'hooks');

          setTimeout(() => {
            for (let i = 0; i < this.paramList.length; i++) {
              const elm = this.paramList[i];
  
              for (let j = 0; j < this.hooks.length; j++) {
                const hook = this.hooks[j];
              
                if(elm.hook == hook.id){
                  console.log(elm.hook, i);
                  (<HTMLInputElement>document.getElementById('hook-' +i )).value = elm.hook;
                }
              }
              
              
            }
          },200)




        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
      function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);

        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      }
    );

    return uuid;
  }

  onFileChanged(event, index){
    const attachment = (event.target as HTMLInputElement).files[0];
    this.attachmentObj = attachment;
    console.log(this.attachmentObj);
    this.addBannerImage(index);

}

addBannerImage(index) {

  var folder = this.routeID == 'banners' ? 'banners' : 'banners-employer';

  this.fileUploaderService.uploadBannerImg(this.attachmentObj, folder,(err,result) => {
  
    if(result == false){
      alert('Error while uploading image');
    }
    else{
      
      var banner = result;
       
      //add banner to paramslist

      this.paramList[index].image = banner;

    }
 })
}


  addLine(){


      if(this.routeID == 'opening-categories'){
        var idx = this.paramList.length + 1;
        this.paramList.push({
          
            id: this.generateUUID(),
            name_fi: "",
            name_en: "",
            order_number: idx,
            hook: "",
            emoji: "",
        })
      }
      else if(this.routeID == 'banners' || this.routeID == 'banners-employer'){
        var idx = this.paramList.length + 1;
        this.paramList.push({
          
            id: this.generateUUID(),
            country_code: "",
            start_date: "",
            end_date: "",
            image: "",
            order_number: idx,
            link: "",
            banner_type: "",
            click_count: 0,
        
        })
      }
  }

  removeLine(index){
    this.paramList.splice(index, 1);
  }

  saveChanges(){
    console.log(this.paramList);

    if(this.routeID == 'banners' || this.routeID == 'banners-employer'){
      this.validateBanners();
    }
    else if (this.routeID == 'opening-categories'){
      this.validateOpeningCategories();
    }
    //Check if same some elements have the same order number
    var orderList = [];

    for (let i = 0; i < this.paramList.length; i++) {
      const elm = this.paramList[i];

      if(orderList.includes(elm.order_number)){
        alert('Order number must be unique Check number ' + elm.order_number);
        return;
      }
      else{
        orderList.push(elm.order_number);
      }
      
    }

    this.http.put(environment.PARAMS_UPDATE + '/'+this.routeID, this.paramList, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          alert('Changes saved');

        }
        else {
          alert('Error while saving changes');

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
    
  }

  validateOpeningCategories(){
    for (let i = 0; i < this.paramList.length; i++) {
      const elm = this.paramList[i];

      if(elm.name_fi == "" || (elm.order_number < 0)){
        console.log(elm);
        alert('Name and order number must be filled');
        return;
      }
      elm.order_number = parseInt(elm.order_number);
      
    }
  }

  updateText(index, key, type){
  
    if(type == 'input'){
      var elm = (<HTMLInputElement>document.getElementById(key + '-'+ index)).value;
    }
    else if (type == 'select'){
      var elm = (<HTMLSelectElement>document.getElementById(key + '-'+ index)).value;
    }

    this.paramList[index][key] = elm;

    console.log(this.paramList);
   
  }

  validateBanners(){
    //Check if order number, start date and end date and image and country code are filled
    for (let i = 0; i < this.paramList.length; i++) {
      const elm = this.paramList[i];

      if(elm.start_date == "" || elm.end_date == "" || elm.image == "" || elm.link == "" || elm.country_code == "" || (elm.order_number < 0)){
        console.log(elm);
        alert('Start date, end date, image, link, country code and order number must be filled');
        return;
      }
      elm.order_number = parseInt(elm.order_number);
      
    }

  }



}
